export const MEMO_PRICE_TYPES = {
  HOURLY: 'HOURLY',
  FIXED: 'FIXED'
};
